import { createElement } from 'react';
import { b as __rest, ab as LoadingIndicator$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var LoadingIndicator = function LoadingIndicator(_a) {
  var variant = _a.variant,
    props = __rest(_a, ["variant"]);
  return /*#__PURE__*/createElement(LoadingIndicator$1, __assign({
    variant: variant === 'L1' ? 'full-screen' : variant
  }, props));
};
LoadingIndicator.displayName = 'LoadingIndicator';

export { LoadingIndicator };
